import { useUserPermissions } from 'api/hooks';

const ReactQueryProvider = ({ children }) => {
  useUserPermissions()

  return children
};

export default ReactQueryProvider;